import { Wizard, WizardStep } from '@factorialco/deprecated-design-system'
import { FormikProvider } from 'formik'

import { useForm } from 'modules/core/hooks/useForm'
import i18n from 'modules/core/lib/i18n'

import AttachmentsStep from './Steps/AttachmentsStep'
import { WizardData } from './types'

interface Props {
  onClose: () => void
  onSuccess: (files: File[]) => void
  loading: boolean
}

const DocumentsUploadWizard = ({ onClose, onSuccess, loading }: Props) => {
  const form = useForm<WizardData>({
    defaultValues: { files: [] },
    onSubmit: async (values) => {
      onSuccess(values.files)
      return { success: true, data: values.files }
    },
  })

  const steps: WizardStep<WizardData>[] = [
    {
      title: i18n.t('attachments.upload_files.title'),
      nextText: i18n.t('common.upload'),
      render: (props) => <AttachmentsStep {...props} />,
      isCompleted: (data) => data.files && data.files.length > 0,
    },
  ]
  const onOpenAutoFocus = () => {}

  return (
    <FormikProvider value={form}>
      <Wizard.Modal
        title={i18n.t('attachments.upload_files.title')}
        icon="upload"
        steps={steps}
        initialData={form.initialValues}
        onSubmit={
          loading
            ? () => null
            : (data: WizardData) => {
                onSuccess(data.files)
              }
        }
        onClose={onClose}
        onDataChanged={form.setValues}
        onOpenAutoFocus={onOpenAutoFocus}
      />
    </FormikProvider>
  )
}

export default DocumentsUploadWizard
